import { createDp } from './_dp.js'
import { createListBox } from './_listbox.js'
import { pad } from './utils.js'
import { compareAsc, addHours } from 'date-fns'

const mq = window.matchMedia("(min-width: 576px)");

async function createParkingWidgetV1($form) {
  // eslint-disable-next-line
  let entryDatePicker
  let exitDatePicker
  let initialEntry, initialExit, initialEntryTime, initialExitTime, now

  $form.addEventListener("submit", e => {
    $form.querySelector("[type=submit] .js-spinner").hidden = false
  })

  now = new Date()

  if ($form.getAttribute('data-initial-entry-date') && $form.getAttribute('data-initial-entry-date') != '') {
    let initialEntryDateValue = $form.getAttribute('data-initial-entry-date')
    let initialEntryTimeValue = $form.getAttribute('data-initial-entry-time')
    let [day, month, year] = initialEntryDateValue.split('/')
    let [hours, minutes] = initialEntryTimeValue.split(":")
    initialEntry = new Date(year, month, day, hours, minutes, 0, 0)
    initialEntryTime = `${pad('00', initialEntry.getHours().toString())}:${pad('00', (Math.floor(initialEntry.getMinutes() / 15) * 15).toString())}`
  } else {
    initialEntry = addHours(now, 5)
    initialEntryTime = `${pad('00', initialEntry.getHours().toString())}:00`
  }

  if (initialEntryTime === '00:00') {
    // set to 1 min past to match AeroParker
    initialEntryTime = '00:01'
  }

  let hasMinAndMax = $form.hasAttribute('data-min-time') && $form.hasAttribute('data-max-time')
  if (hasMinAndMax) {
    let [initialEntryHours] = initialEntryTime.split(':')
    let min = parseInt($form.getAttribute('data-min-time'), 10)
    let max = parseInt($form.getAttribute('data-max-time'), 10)
    if (parseInt(initialEntryHours, 10) < min) {
      initialEntryTime = `${pad('00', min.toString())}:00`
    } else if (parseInt(initialEntryHours, 10) > max) {
      initialEntryTime = `${pad('00', max.toString())}:00`
    }
  }

  if ($form.getAttribute('data-initial-exit-date') && $form.getAttribute('data-initial-exit-date') != '') {
    let initialExitDateValue = $form.getAttribute('data-initial-exit-date')
    let initialExitTimeValue = $form.getAttribute('data-initial-exit-time')
    let [exitDay, exitMonth, exitYear] = initialExitDateValue.split('/')
    let [exitHours, exitMinutes] = initialExitTimeValue.split(":")
    initialExit = new Date(exitYear, exitMonth, exitDay, exitHours, exitMinutes, 0, 0)
    initialExitTime = `${pad('00', initialExit.getHours().toString())}:${pad('00', (Math.floor(initialExit.getMinutes() / 15) * 15).toString())}`
  } else {
    initialExit = addHours(now, 6)
    initialExitTime = `${pad('00', initialExit.getHours().toString())}:00`
  }

  if (initialExitTime === '00:00') {
    /**
     * if the initial exit is midnight we set it to 23:59 on the previous day (today)
     */
    initialExit = now
    initialExitTime = '23:59'
  }

  let $entryDate = $form.querySelector('.js-parking-widget-entry-date')
  entryDatePicker = await createDp($entryDate, {
    defaultDate: initialEntry,
    setDefaultDate: true,
    minDate: now,
    numberOfMonths: $form.id === 'lounge-widget-fallback' ? (mq.matches ? 2 : 1) : 1,
    onSelect() {
      if (exitDatePicker) {
        let date = this.getDate()
        exitDatePicker.setMinDate(date)
        if (exitDatePicker.getDate() === null) {
          exitDatePicker.gotoDate(date)
        }
        if (compareAsc(date, exitDatePicker.getDate()) === 1) {
          exitDatePicker.setDate(date)
        }
      }
    },
    container: $entryDate.parentNode.parentNode
  })

  let $exitDate = $form.querySelector('.js-parking-widget-exit-date')
  if ($exitDate) {
    exitDatePicker = await createDp($exitDate, {
      defaultDate: initialExit,
      setDefaultDate: true,
      minDate: now,
      container: $exitDate.parentNode.parentNode,
      numberOfMonths: $form.id === 'lounge-widget-fallback' ? (mq.matches ? 2 : 1) : 1,
    })
  }

  if ($form.querySelector('.js-parking-widget-entry-time')) {
    let entryTime = await createListBox(
      $form.querySelector('.js-parking-widget-entry-time')
    )
    if (!entryTime.getValue()) {
      entryTime.setValue(initialEntryTime)
    }
  }

  if ($form.querySelector('.js-parking-widget-exit-time')) {
    let exitTime = await createListBox(
      $form.querySelector('.js-parking-widget-exit-time')
    )
    if (!exitTime.getValue()) {
      exitTime.setValue(initialExitTime)
    }
  }

  if ($form.querySelector('.js-parking-widget-adults')) {
    let adults = await createListBox(
      $form.querySelector('.js-parking-widget-adults')
    )
    if (!adults.getValue()) {
      adults.setValue(1)
    }
  }

  if ($form.querySelector('.js-parking-widget-children')) {
    let children = await createListBox(
      $form.querySelector('.js-parking-widget-children')
    )
    if (!children.getValue()) {
      children.setValue(0)
    }
  }
}

let $form = document.querySelector('.js-parking-widget-v1')

if ($form) createParkingWidgetV1($form)

export default createParkingWidgetV1



// WEBPACK FOOTER //
// ./src/js/_parking-widget-v1.js